import React from "react";
import styled from "styled-components";
import { PostData } from "../Functions/SendingData";
import { insertError } from "../StakcableError";
import { Link } from "react-router-dom";
import { changePrice, checkPriceCut, formatPrice } from "../Functions/Price";
import Like from '../../assets/newSvg/act-like';
import { useState } from "react";
import moreShop from '../../assets/newSvg/moreshop.png';
import oneShop from '../../assets/newSvg/one-shop.png'
import twoShop from '../../assets/newSvg/two-shop.png'
import { Addvert } from "../../App";
import { LazyImage } from "../Scomp/LazyImage";

const Style = styled(Link)`
    display: flex;
    flex-direction: column;
    width: 100%;
    /* background: var(--stand-bg); */
    background: #fff;
    box-shadow: var(--shadow-22);
    border-radius: var(--border-radius-9);
    text-decoration:none;
    :hover{
        .top-part-good {
            .stand {
                filter: saturate(140%);
            }
            .g-image {
                .main {
                    transform: scale(1.1);
                }
                .reflection{
                    transform: scale(1.1, -1);
                }
                .shadow{
                    filter: brightness(0.8) blur(10px);
                    transform-origin: bottom;
                    /* transform: skewX(0deg); */
                    /* clip-path: ellipse(0% 0% at bottom); */
                }
            }
        }
    }
    .top-part-good {
        position: relative;
        align-items: center;
        width: 100% ;
        height: 100%;
        text-decoration: none;
        display:flex;
        flex-direction: column;
        .like{
            display: flex;
            width: 1.5rem;
            aspect-ratio: 1;
            position: absolute;
            top: 1rem;
            right: 1rem;
            padding: 0.2rem;
            z-index: 1;
            border: var(--border-style-2);
            cursor: pointer;
            background: var(--body-2);
            border-radius: var(--border-radius-2);
        }
        .stand{
            position: absolute;
            inset: 0;
            width: 100%;
            height: 100%;
            aspect-ratio: 1;
            object-fit: cover;
            border-radius: var(--border-radius-9);
            transition: all 0.3s ease-in-out;
        }
        
        .g-image{
            position: relative;
            display: block;
            width: 100%;
            height: 100%;
            aspect-ratio: 1;
            border-radius: var(--border-radius-9);
            color: var(--text-3);
            position: relative;
            overflow: hidden;
            .shadow {
                position: absolute;
                width: 52.4%;
                height: 10%;
                display: block;
                left: calc(50% - calc(55% / 2));
                padding-top: calc(28% + 41%);
                margin: auto;
                object-fit: fill;
                transition: all 0.3s ease-in-out;
                transform-origin: bottom;
                opacity: 0.4;
                filter: brightness(0.8) blur(3px);
                transform-origin: bottom;
                transform: skewX(60deg);
                clip-path: ellipse(38% 3% at bottom);
            }
            .reflection{
                position: absolute;
                width: 52.4%;
                height: 20%;
                display: block;
                left: calc(50% - calc(52.5% / 2));
                padding-top: calc(28% + 31%);
                margin: auto;
                object-fit: fill;
                transition: all 0.3s ease-in-out;
                transform-origin: bottom;
                opacity: 0.4;
                filter: brightness(1.8) blur(2px);
                transform-origin: bottom;
                transform: scale(1, -1);
                clip-path: ellipse(57% 7% at bottom);
            }
            .main{
                position: relative;
                width: 52.4% ;
                display: block;
                padding-top: 28%;
                margin: auto;
                object-fit: contain;
                transition: all 0.3s ease-in-out;
                transform-origin: bottom;
            }
        }
        /* .model2{
            .main{
                padding-top: 33%;
            }
            .reflection{
                padding-top: calc(31% + 31%);
            }
            .shadow{
                padding-top: calc(31% + 41%);
            }
        } */
        .model3{
            .reflection{
                clip-path: ellipse(70% 9.5% at bottom);
            }
            .shadow{
                clip-path: ellipse(60% 6% at bottom);
            }
            :hover{
                .shadow{
                    /* clip-path: ellipse(38% 7% at bottom); */
                }
            }
        }
        @media screen and (max-width: 850px){
        
            .g-image{
                img{
                    width: 55%;
                }
            }        
        }
    }
    .g-data{
        display: flex;
        flex-direction: column;
        justify-content: flex-start;
        position: relative;
        width:calc(100% - 2.4rem);
        padding: 1rem  1.2rem;
        color: var(--text-9);
        .actions{
            display: flex;
            flex-direction: row;
            justify-content: flex-end;
            align-items: center;
            .act{
                display: flex;
                position: relative;
                padding: 0.2rem;
                width: 1.5rem;
                height: 1.5rem;
                margin-right: 0.5rem;
                svg{
                    fill:var(--gray-8)
                }
                &.red-like{
                    background: rgba(204, 33, 41, 0.1);
                    svg{
                        fill:var(--secondry-5);
                    }
                }
            }
        }
        .g-name{
            font-weight: 400;
            font-size: 1rem;
            text-align: right;
            color: var(--text-2);
        }
        .bottom-data {
            display: flex;
            justify-content: space-between;
            align-items: center;
            .price-cat {
                display: flex;
                flex-direction: column;
                position: relative;
                .percent {
                    /* content: "15%"; */
                    /* width: 1.5rem; */
                    padding: 0.2rem 0.3rem 0.1rem;
                    font-size: 0.7rem;
                    background-color: #d32f2f;
                    color: #fff;
                    position: absolute;
                    top: 0;
                    right: -2.0rem;
                    z-index: 10;
                    border-radius: 100px;
                }
                .cut {
                    /* text-decoration: line-through; */
                    color: var(--gray-6);
                    position: relative;
                    isolation: isolate;
                    &::after {
                        content: " ";
                        width: calc(100% + 6px);
                        height: 2px;
                        background-color: #ff000088;
                        position: absolute;
                        top: calc(50% - 2px);
                        left: -3px;
                        z-index: 10;
                        border-radius: 100px;
                    }
                }
            }
            .price {
                font-weight: 700;
                display: flex;
                gap: 0.3rem;
                &.no-good {
                    color: var(--gray-6);
                }
            }
        }
        .br{
            display: flex;
            flex-direction: row;
            align-items: center;
            font-weight: 500;
            color: var(--gray-6);
            font-size: 0.75rem;
            gap: 0.5rem;
            .logo{
                border-radius: var(--border-radius-7);
                border: var(--border-style-2);
                width: 2rem;
                aspect-ratio: 1;
            }
        }
        .g-shop{
            display: flex;
            flex-direction: row;
            justify-content: flex-start;
            align-items: center;
            border-top: var(--border-style-2);
            margin-top: 0.5rem;
            padding-top: 0.5rem;
            position: relative;
            height: 1.5rem;
            .name-shop{
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                width: calc(100% - 3rem);
                position: relative;
                font-weight: 500;
                font-size: 0.87rem;
                color: var(--gray-6);
                margin-right: 0.5rem;
            }
            .more-shop{
                position: relative;
                width: fit-content;
                margin-right: -0.5rem;
                transform: rotate(180deg);
            }
            .img-shop{
                position: absolute;
                right: 1.5rem;
                width: 1.5rem;
                aspect-ratio: 1;
                border-radius: var(--border-radius-7);
                z-index: 999;
                background-color: var(--body-2);
            }
            .one{
                right: 0.5rem;
            }
            .two{
                right: 1rem;
            }
        }
    }
    @media screen and (max-width : 850px){
        .top-part-good{
            .like{
                top: 0.75rem;
                right: 0.75rem;
            }
            .stand{
                border-radius: 0 var(--border-radius-9) var(--border-radius-9) 0;
            }
        }
        &.in-row{
            flex-direction: row;
            box-shadow: none;
            .like{
                top: 0.75rem;
                right: 0.75rem;
            }
        }
    }
`

const GoodCartInfoHomeV2Main = React.forwardRef((props, ref)=>{
    let data = props.data
    let shop = (window.location.pathname === '/')
    const [like , setLike] = useState(parseInt(data.is_favorite))

    const setFav=(e,G_CODE,SH_CODE)=>{
        e.preventDefault()
        e.stopPropagation();
        if(!localStorage.getItem("token")){
          insertError('برای افزودن به علاقه‌مندی‌ها لازم است وارد حساب کاربری شوید', "red", 5000);
          return;
        }
        let formData = new FormData();
        formData.append("api_token", localStorage.getItem("token"));
        formData.append("U_CODE",  JSON.parse(localStorage.getItem('userdata')).usercode);
        formData.append("G_CODE", G_CODE);
        formData.append("SH_CODE", SH_CODE ?? -1);
        PostData(
            process.env.REACT_APP_API + "/api/v1/goods/user_views/favorite_update",
            formData,
            '',
            processLike
        );
    }
    const processLike=(obj, response)=>{
        response = JSON.parse(response);
        if (response.status === "success") {
          setLike(parseInt(response.data.is_favorite))
        } else if (response.status === "error") {
          insertError(response.message, "red", 5000)
        } else if (response.status === "error-no-internet") {
          insertError(response.message, "red", 5000)
        }
    }

    const GoodImage =()=>{
        let newimage = data.G_IMAGE.replace(process.env.REACT_APP_API+"/images", process.env.REACT_APP_CACHE);
        newimage = newimage.replace(process.env.REACT_APP_API2+"/images", process.env.REACT_APP_CACHE);
        let modelClass = 'model'+data.G_TAG_MODEL

        let standimage = data.G_TAG_MODEL_IMG;
        if(data.G_TAG_MODEL_IMG){
            standimage = data.G_TAG_MODEL_IMG.replace(process.env.REACT_APP_API+"/images", process.env.REACT_APP_CACHE);
            standimage = standimage.replace(process.env.REACT_APP_API2+"/images", process.env.REACT_APP_CACHE);
        }
        return(
            <div 
                ref={ref}
                key={props.keys}
                index={props.index}
                className="top-part-good"
            >   
                <div className="like" style={{borderColor : ((like === 1) ? 'var(--secondry-5)' : '')}} onClick={(e)=>setFav(e,data.G_CODE , data.SH_CODE)}>
                    <Like classname={(like === 1) ? 'like-red' : 'like-gray'}/>
                </div>
                {/* <LazyImage className="stand" alt={"stand"} src={props.standimg} /> */}
                <img className="stand " alt={"stand"} src={standimage + "?size=500"} />
                <div className={"g-image " + modelClass }>
                    <LazyImage className="shadow" src={newimage + "?size=250"} alt={data.G_NAME}/>
                    <LazyImage className="reflection" src={newimage + "?size=250"} alt={data.G_NAME}/>
                    <LazyImage className="main" src={newimage + "?size=250"} alt={data.G_NAME}/>
                </div>
            </div>
        )
    }
    const getPrice = () => {
        if(data.AVAILABLE === 0){
            return (
                <div className="price no-good">
                    نا موجود
                </div>
            )
        }
        if(data.SH_G_DISCOUNT_PERCENT_MAX){
            return (
                <div className="price-cat">
                    <div className="price cut">
                        از <div>{formatPrice(data.SH_G_DISCOUNT_PRICE_MAX)}</div> تومان
                        <span className="percent">{data.SH_G_DISCOUNT_PERCENT_MAX}%</span>
                    </div>
                    <div className="price">
                        از <div>{formatPrice(data.SH_G_PRICE)}</div> تومان
                    </div>
                </div>
            )
        }
        if(data.SH_G_PRICE){
            return (
                <div className="price">
                    از <div>{formatPrice(data.SH_G_PRICE)}</div> تومان
                </div>
            )
        }

        if(data.Min){
            return (
                <div className="price">
                    از <div>{formatPrice(data.Min)}</div> تومان
                </div>
            )
        }
        return (
            <div className="price no-good">
                نا موجود
            </div>
        )
    }

    const shopsCount=()=>{
        if(shop){
            let def_shop = data.default_shop
            let shops = ''
            let img = ''
            let classShop =''
            let shopimage = "";
            
            if(def_shop){
                shops = def_shop.SH_NAME + ' و '  + data.shop_count +' فروشگاه دیگر ' 
                img = <LazyImage src={moreShop} alt="فروشگاه دیگر" className="more-shop " />
                if(data.shop_count === 1){
                    img = <LazyImage src={oneShop} alt="فروشگاه دیگر" className="more-shop" />
                    classShop = 'one'
                }else if(data.shop_count === 2){
                    img = <LazyImage src={twoShop} alt="فروشگاه دیگر" className="more-shop" />
                    classShop = 'two'
                }else if(data.shop_count === 0){
                    shops = def_shop.SH_NAME
                    img = ''
                }
                shopimage = def_shop.SH_LOGO;
                if(def_shop.SH_LOGO){
                    shopimage = def_shop.SH_LOGO.replace(process.env.REACT_APP_API+"/images", process.env.REACT_APP_CACHE);
                    shopimage = shopimage.replace(process.env.REACT_APP_API2+"/images", process.env.REACT_APP_CACHE);
                }
            }
            
            
            return(
                <div  className="g-shop">
                    {img} 
                    {def_shop ? <LazyImage src={shopimage + "?size=150"} alt="img-shop" className={"img-shop " + classShop} style={{right:(data.shop_count===0 ? 0 : '')}}/> : ''}
                    <span className="name-shop" style={{marginRight:(data.shop_count === 0 ? '2rem' : '')}} >{shops}</span>
                </div>
            ) 
        }
    }
    let stateShop = window.location.pathname.split('/')[1]
    let stateVal=''
    if(stateShop === 'shop'){
        stateVal = { pathname: encodeURI(`/good/${data.G_CODE}/${data.G_URL}/`), search:`?shop=${props.shopcode}` }
    }else{
        stateVal = { pathname: encodeURI('/good/'+ data.G_CODE+'/' + data.G_URL+'/')}
    }
    let brandimage = data.G_BR_IMG;
    if(data.G_BR_IMG){
        brandimage = data.G_BR_IMG.replace(process.env.REACT_APP_API+"/images", process.env.REACT_APP_CACHE);
        brandimage = brandimage.replace(process.env.REACT_APP_API2+"/images", process.env.REACT_APP_CACHE);
    }
    return (
        <Style 
            to={stateVal}
            className={(props.type === 'favorite') ? 'in-row' : ''}
        >
            {GoodImage()}
            <div className="g-data " style={{minHeight:( shop? '8rem' : '5.5rem')}}>
                <span className="g-name">{data.G_NAME}</span>
                <span style={{flexGrow: '1'}}></span>
                <div className="bottom-data">
                    <div className="g-name br">
                        <LazyImage src={brandimage+"?size=150"} alt={data.G_BR_NAME} className="logo"/>
                        {data.G_BR_NAME}
                    </div>
                    {getPrice()}
                </div>
                {shopsCount()}
            </div>
        </Style>
    )
})
export default GoodCartInfoHomeV2Main
